var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericCard = function SvgGenericCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B61FF",
    fillRule: "evenodd",
    d: "M32 1H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B61FF",
    d: "M5 13h26v2H5zM5 17h8v2H5z"
  })));
};
export { SvgGenericCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAzNiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyIDFINEMyLjM0MzE1IDEgMSAyLjM0MzE1IDEgNFYyMEMxIDIxLjY1NjkgMi4zNDMxNSAyMyA0IDIzSDMyQzMzLjY1NjkgMjMgMzUgMjEuNjU2OSAzNSAyMFY0QzM1IDIuMzQzMTUgMzMuNjU2OSAxIDMyIDFaTTQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNFYyMEMwIDIyLjIwOTEgMS43OTA4NiAyNCA0IDI0SDMyQzM0LjIwOTEgMjQgMzYgMjIuMjA5MSAzNiAyMFY0QzM2IDEuNzkwODYgMzQuMjA5MSAwIDMyIDBINFoiIGZpbGw9IiM3QjYxRkYiLz4KICA8cGF0aCBkPSJNNSAxM0gzMVYxNUg1VjEzWiIgZmlsbD0iIzdCNjFGRiIvPgogIDxwYXRoIGQ9Ik01IDE3SDEzVjE5SDVWMTdaIiBmaWxsPSIjN0I2MUZGIi8+Cjwvc3ZnPgo=";